import React from "react";
import WarehousePage from "./WarehousePage";

export default function WarehouseOrderHistory(props) {
    return (
        <WarehousePage
            {...props}
            page="orderHistory"
        />
    );
}